import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { PlanningDetails } from '../planning-details.dto';
import { PumpRoomDesign } from './pump-room-design';
import { SprinklerSystemDesign } from './sprinkler-design/sprinkler-system-design.dto';

export class InspectionDesignDto extends InspectionCase {
  sprinklerSystemDesign?: SprinklerSystemDesign;
  pumpRoomDesign?: PumpRoomDesign;
  planningDetails?: PlanningDetails;
  summaryNotes?: SummaryNotes[];
}

export class InspectionDesign
  extends InspectionDesignDto
  implements Inspection
{
  constructor(
    data: InspectionDesignDto = {
      title: 'בדיקת תכנון מערכות מתזים במים',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);

    this.summaryNotes = data.summaryNotes;
    this.sprinklerSystemDesign = new SprinklerSystemDesign(
      data.sprinklerSystemDesign
    );
    this.pumpRoomDesign = new PumpRoomDesign(data.pumpRoomDesign);
    this.planningDetails = new PlanningDetails(data.planningDetails);
  }

  setInspectionStatus(): void {
    this.sprinklerSystemDesign.setInspectionStatus();
    this.pumpRoomDesign.setInspectionStatus();

    this.isPassed =
      this.sprinklerSystemDesign.isPassed && this.pumpRoomDesign.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.sprinklerSystemDesign.getNotes(),
      ...this.pumpRoomDesign.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.sprinklerSystemDesign.setAsApplicable();
    this.pumpRoomDesign.setAsApplicable();
  }

  getCases(): Cases[] {
    return [
      {
        title: this.sprinklerSystemDesign.title,
        cases: [
          this.sprinklerSystemDesign.main,
          this.sprinklerSystemDesign.closedWaterSprinklerSystems,
          this.sprinklerSystemDesign.waterFloodingSystems,
          this.sprinklerSystemDesign.preactionSystems,
          this.sprinklerSystemDesign.deploymentAgainstEarthquakes,
          this.sprinklerSystemDesign.foamCenter
        ]
      },
      {
        title: this.pumpRoomDesign.title,
        cases: [
          this.pumpRoomDesign.fireExtinguishingPumps,
          this.pumpRoomDesign.fireExtinguishingReservoir
        ]
      }
    ];
  }
}
